var _mask, _path, _path2, _mask2, _path3, _rect, _mask3, _path4, _mask4, _path5, _rect2, _rect3, _circle, _rect4, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBgReactangleExtension3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 269,
    height: 442,
    viewBox: "0 0 269 442",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_1061_1396",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.3563 368.483H194.944V273.612L0.880981 0.368896L84.3563 368.483Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M84.3563 368.483H194.944V273.612L0.880981 0.368896L84.3563 368.483Z",
    fill: "#FD4C00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M83.8564 368.488L82.869 273.617L83.8689 273.607L84.8563 368.477L83.8564 368.488ZM83.3689 273.112H194.944V274.112H83.3689V273.112ZM82.8903 273.757L0.402317 0.513398L1.35965 0.224395L83.8476 273.468L82.8903 273.757ZM194.944 368.483H195.944V369.483H194.944V368.483ZM84.3563 368.483V369.483H83.5577L83.3811 368.704L84.3563 368.483ZM0.880981 0.368896L-0.0942583 0.590047L1.69628 -0.210145L0.880981 0.368896ZM194.944 273.612L195.759 273.033L195.944 273.293V273.612H194.944ZM194.944 369.483H84.3563V367.483H194.944V369.483ZM83.3811 368.704L-0.0942583 0.590047L1.85622 0.147746L85.3316 368.261L83.3811 368.704ZM195.944 273.612V368.483H193.944V273.612H195.944ZM194.129 274.191L0.0656834 0.947938L1.69628 -0.210145L195.759 273.033L194.129 274.191Z",
    fill: "#101010",
    mask: "url(#path-1-inside-1_1061_1396)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-2_1061_1396",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M113.802 302.736C113.802 301.079 115.145 299.736 116.802 299.736H162.594C164.251 299.736 165.594 301.079 165.594 302.736V332.58C165.594 335.894 162.908 338.58 159.594 338.58H119.802C116.488 338.58 113.802 335.894 113.802 332.58V302.736Z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M113.802 302.736C113.802 301.079 115.145 299.736 116.802 299.736H162.594C164.251 299.736 165.594 301.079 165.594 302.736V332.58C165.594 335.894 162.908 338.58 159.594 338.58H119.802C116.488 338.58 113.802 335.894 113.802 332.58V302.736Z",
    fill: "#EFE4D2",
    stroke: "#EFE4D2",
    strokeWidth: 2,
    mask: "url(#path-3-inside-2_1061_1396)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.404631,
    y: 0.404631,
    width: 8.90189,
    height: 0.809263,
    transform: "matrix(-4.37114e-08 1 1 4.37114e-08 139.702 291.643)",
    fill: "#EFE4D2",
    stroke: "#EFE4D2",
    strokeWidth: 0.809263
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "path-5-inside-3_1061_1396",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M173.692 309.209C173.692 307.553 172.349 306.209 170.692 306.209H167.218V330.487H170.692C172.349 330.487 173.692 329.144 173.692 327.487V309.209Z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M173.692 309.209C173.692 307.553 172.349 306.209 170.692 306.209H167.218V330.487H170.692C172.349 330.487 173.692 329.144 173.692 327.487V309.209Z",
    fill: "#EFE4D2",
    stroke: "#EFE4D2",
    strokeWidth: 2,
    mask: "url(#path-5-inside-3_1061_1396)"
  })), _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    id: "path-6-inside-4_1061_1396",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.183 306.209H108.709C107.052 306.209 105.709 307.553 105.709 309.209V327.487C105.709 329.144 107.052 330.487 108.709 330.487H112.183V306.209Z"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M112.183 306.209H108.709C107.052 306.209 105.709 307.553 105.709 309.209V327.487C105.709 329.144 107.052 330.487 108.709 330.487H112.183V306.209Z",
    fill: "#EFE4D2",
    stroke: "#EFE4D2",
    strokeWidth: 2,
    mask: "url(#path-6-inside-4_1061_1396)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 123.013,
    y: 308.947,
    width: 9.09262,
    height: 15.5667,
    rx: 4.54631,
    fill: "#FD4C00",
    stroke: "#EFE4D2"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 147.291,
    y: 308.947,
    width: 9.09262,
    height: 15.5667,
    rx: 4.54631,
    fill: "#FD4C00",
    stroke: "#EFE4D2"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 140.503,
    cy: 290.834,
    r: 3.54631,
    fill: "#EFE4D2",
    stroke: "#EFE4D2"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 195.569,
    y: 368.63,
    width: 72.3231,
    height: 72.3231,
    fill: "#FD4C00",
    stroke: "#101010"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M246.05 387.607H217.408C215.826 387.607 214.544 388.889 214.544 390.471V419.113C214.544 420.695 215.826 421.977 217.408 421.977H246.05C247.632 421.977 248.914 420.695 248.914 419.113V390.471C248.914 388.889 247.632 387.607 246.05 387.607Z",
    fill: "#EFE4D2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M236.504 407.656H226.956V413.385H236.504V407.656Z",
    fill: "#FD4C00",
    stroke: "#FD4C00",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M241.276 400.018H222.181V407.656H241.276V400.018Z",
    fill: "#FD4C00",
    stroke: "#FD4C00",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M240.322 400.018V396.199Z",
    fill: "#EFE4D2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M240.322 400.018V396.199",
    stroke: "#FD4C00",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M234.593 400.018V396.199Z",
    fill: "#EFE4D2"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M234.593 400.018V396.199",
    stroke: "#FD4C00",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M228.865 400.018V396.199Z",
    fill: "#EFE4D2"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M228.865 400.018V396.199",
    stroke: "#FD4C00",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M223.137 400.018V396.199Z",
    fill: "#EFE4D2"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M223.137 400.018V396.199",
    stroke: "#FD4C00",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgReactangleExtension3);
export default __webpack_public_path__ + "static/media/bgReactangleExtension3.ad94d20fa7ab2769362506f245f8a72c.svg";
export { ForwardRef as ReactComponent };